import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { openNotification } from "../../utils/funciones";
import { MALA_ACCION } from "../../utils";

//Consulta de Vacantes

const GET_ESTADOS = "GET_ESTADOS";
const GET_ESTADOS_PUESTOS = "[CATALOGO] GET_ESTADOS_PUESTOS";
const ASIGNAR_IDESTADO = "[CATALOGO] ASIGNAR_IDESTADO";
const NOMBRE_ESTADO = "[CATALOGO] NOMBRE_ESTADO";
const GET_ESTADOS_ERROR = "GET_ESTADOS_ERROR";
const GET_ERROR_ESTADOS_SERVICE = "GET_ERROR_ESTADOS_SERVICE";
const CLEAN_STATE = "CLEAN_STATE";

//------------- STATE -------------------------

const datosIniciales = {
  //Catalogo de estados
  estados: [],
  message: "",
  //Estados con cargo/puesto
  estadospuesto: [0],
  idEstado: null,
  nombreEstado: "",
};

//------------- REDUCER -------------------------
const obtenerEstadoReducer = (state = datosIniciales, action) => {
  switch (action.type) {
    case GET_ESTADOS:
      return {
        ...state,
        estados: action.payload,
      };
    case GET_ESTADOS_PUESTOS:
      return {
        ...state,
        estadospuesto: [...action.payload],
      };

    case ASIGNAR_IDESTADO:
      return {
        ...state,
        idEstado: action.payload,
      };

    case NOMBRE_ESTADO:
      return {
        ...state,
        nombreEstado: action.payload,
      };
    case GET_ESTADOS_ERROR:
      return {
        ...state,
        message: MALA_ACCION,
        estados: [],
      };
    case GET_ERROR_ESTADOS_SERVICE:
      return {
        ...state,
        estados: [],
      };
    case CLEAN_STATE:
      return datosIniciales;

    default:
      return state;
  }
};

export default obtenerEstadoReducer;

//------------- ACTIONS -------------------------
/**
 * Array de estados
 * @param {object[]} state
 * @returns
 */
export const getObtEstados = (state) => ({
  type: GET_ESTADOS,
  payload: state,
});

export const getObtEstadosPuesto = (state) => ({
  type: GET_ESTADOS_PUESTOS,
  payload: state,
});

export const getNombreEstado = (nombreEstado) => async (dispatch) => {
  dispatch({
    type: NOMBRE_ESTADO,
    payload: nombreEstado,
  });
};

export const asignarIdestado = (idEstado) => ({
  type: ASIGNAR_IDESTADO,
  payload: idEstado,
});

export const cleanCatalogo = () => ({
  type: CLEAN_STATE,
});

export const obtenerEstado = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerEstados}`
    );
    dispatch(getObtEstados(data));
  } catch (error) {
    openNotification(GET_ESTADOS_ERROR, "");
  }
};

export const obtenerEstadosPuesto =
  (idConcurso, idConvocatoria) => async (dispatch) => {
    try {
      const urls = await axios(window.location.origin + JSON_URL);
      const { data } = await axios.post(
        `${urls.data.urlServer}${urls.data.urlObtenerEstadosPuestos}`,
        { idConcurso, idConvocatoria }
      );
      dispatch(getObtEstadosPuesto(data));
    } catch (error) {
      openNotification(GET_ESTADOS_ERROR, "");
    }
  };
